import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function Yearpavati() {
  const location = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem("language");
  const { schoolDetails, feeDetails, dateFrom, dateTo } = location.state || {};

  const [studentData, setStudentData] = useState({});
  const [isDataFetched, setIsDataFetched] = useState(false);

  /* ---------------- DATE FORMAT ---------------- */
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  /* ---------------- FETCH STUDENTS ---------------- */
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`
        );
        const data = await res.json();
        setStudentData(data || {});
        setIsDataFetched(true);
      } catch (err) {
        console.error(err);
      }
    };
    fetchStudentData();
  }, [udiseNumber]);

  /* ---------------- FIXED FEE LOGIC ---------------- */
  const organizeFeeDetails = () => {
    if (!feeDetails || feeDetails.length === 0) {
      return { invoiceGroups: {} };
    }

    const invoiceGroups = {};
    const studentLastPay = {};
    const fromDate = dateFrom ? new Date(dateFrom) : null;
    const toDate = dateTo ? new Date(dateTo) : null;

    const sorted = [...feeDetails].sort((a, b) => {
      const dateCompare = new Date(a.date) - new Date(b.date);
      return dateCompare !== 0 ? dateCompare : a.invoiceNo - b.invoiceNo;
    });

    sorted.forEach((fee) => {
      const beforePay = parseFloat(fee.beforePay || 0);
      const studentKey = fee.serialNo;
      const feeDate = new Date(fee.date);

      if (!studentLastPay[studentKey]) {
        studentLastPay[studentKey] = 0;
      }

      const paidAmount = beforePay - studentLastPay[studentKey];
      const isInRange = (!fromDate || feeDate >= fromDate) && (!toDate || feeDate <= toDate);

      if (isInRange) {
        if (!invoiceGroups[fee.date]) {
          invoiceGroups[fee.date] = {};
        }

        if (!invoiceGroups[fee.date][fee.invoiceNo]) {
          invoiceGroups[fee.date][fee.invoiceNo] = {
            class: fee.class,
            division: fee.division,
            serialNo: fee.serialNo,
            invoiceNo: fee.invoiceNo,
            pavatiDate: fee.date,
            transactionType: fee.transaction,
            beforePay,
            paidAmount,
          };
        }
      }

      studentLastPay[studentKey] = beforePay;
    });

    return { invoiceGroups };
  };

  const { invoiceGroups } = isDataFetched
    ? organizeFeeDetails()
    : { invoiceGroups: {} };

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // Reload to restore original content after print
  };

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };

  return (
    <div className='main-content-of-page'>
      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
        <button
          onClick={handleGoBack}
          style={{
            backgroundColor: '#FFFFFF',
            color: 'black',
            padding: '7px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginRight: '20px',
            border: '1px solid black',
            marginTop: '20px',
            marginLeft: '30px',
          }}
        >
          <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
          Go Back
        </button>
        <button
          onClick={handlePrint}
          style={{
            backgroundColor: '#A31D27',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginLeft: '10px',
            marginTop: '20px'
          }}
        >
          Print Report
        </button>
      </div>

      <div ref={printRef} className="table-container mb-5" style={{
        margin: '20px auto',
        border: '1px solid black',
        overflow: 'hidden',
        width: '1200px',
        padding: '10px'
      }}  >

        <style>
          {`
          table {
              width: 100%;
              border-collapse: collapse;
          }

          thead {
              background-color: #4CAF50;
              color: white;
          }

            @page {
            border: 1px solid black;
              size: auto;
              margin: 3mm;
              padding : 20px;
            }
          th, td {
              padding:10px 8px;
              text-align: center;
              border: 1px solid black;
          }
          tr:hover {
              background-color: #f1f1f1;
          }

          tfoot {
              font-weight: bold;
              background-color: #f9f9f9;
          }
          h5{
          margin-top:30px;}
        `}
        </style>

        <div className="receipt-header" style={{ border: '1px solid black', marginbottom: '10px', backgroundColor: '#F7F7F7', padding: '10px', fontSize: '14px' }} >

          <h8>{schoolDetails?.sansthaName || ' '}</h8>
          <h2 style={{ fontWeight: '600', marginBottom: '4px' }}>{schoolDetails?.schoolName || ' '}</h2>

          <div className='taludis' style={{ textAlign: 'center', marginBottom: '7px' }}>
            <h8>{language === "English" ? "Taluka" : " तालुका"}: {schoolDetails?.taluka},{language === "English" ? "District" : " जिल्हा"} : {schoolDetails?.jilha}</h8>
          </div>

          <h2 style={{
            display: 'block',
            border: '1px solid black',
            backgroundColor: 'black',
            color: 'white',
            padding: '2px',
            width: '180px',
            textAlign: 'center',
            margin: '0 auto',
            borderRadius: '5px', fontSize: '18px'
          }}>{language === "English" ? "Year Report" : " वर्षाचा अहवाल"}</h2>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '1%' }}>
            { /*<p>Division: {division}</p> */}

          </div>
        </div>

        {Object.keys(invoiceGroups).length > 0 ? (
          Object.keys(invoiceGroups).sort((a, b) => new Date(a) - new Date(b)).map(date => (
            <div key={date} style={{ marginTop: '16px' }}>
              <h5 style={{ marginBottom: '5px', marginLeft: '10px', fontSize: '16px' }}>{formatDate(date)}</h5>
              <table style={{ fontSize: '14px' }}>
                <thead>
                  <tr>
                    <th style={{ backgroundColor: '#A31D27' }} > {language === "English" ? "Sr. No" : "अनु.क्र."}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Class" : "वर्ग"}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Division" : "तुकडी"}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>Invoice No</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>Reg. No</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Date" : "तारीख"}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Transaction" : "व्यवहार"}</th>
                    <th style={{ backgroundColor: '#A31D27' }}>{language === "English" ? "Paid Fee" : "दिलेली फी"}</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.values(invoiceGroups[date]).map((group, index) => {
                    const student = studentData[group.serialNo] || {};
                    const paidAmount = parseFloat(group.paidAmount || 0);

                    // Skip this row if the paidAmount is 0 or negative, or student is inactive
                    if (paidAmount <= 0 || student.isActive === false) {
                      return null;
                    }

                    return (
                      <tr key={group.invoiceNo}>
                        <td>{index + 1}</td>
                        <td>{group.class || ' '}</td>
                        <td>{group.division || ' '}</td>
                        <td>{group.invoiceNo || '-'}</td>
                        <td>{student.stdName + " " + (student.stdFather || '') + " " + (student.stdSurname || '')}</td>
                        <td>{student.registerNo || ' '}</td>
                        <td>{formatDate(group.pavatiDate)}</td>
                        <td>{group.transactionType || ' '}</td>
                        <td>{paidAmount.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan="8" style={{ textAlign: 'right' }}>{language === "English" ? "Total Paid Fee" : "एकूण दिलेली फी"} :</td>
                    <td>
                      {Object.values(invoiceGroups[date]).reduce((acc, group) => {
                        const student = studentData[group.serialNo] || {};
                        const paidAmount = parseFloat(group.paidAmount || 0);
                        // Only include paidAmount if the student is active and amount is positive
                        return student.isActive !== false && paidAmount > 0 ? acc + paidAmount : acc;
                      }, 0).toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          ))
        ) : (
          <p>{language === "English" ? "No fee details available." : "कोणतेही शुल्क तपशील उपलब्ध नाहीत."}</p>
        )}

        {/* GRAND TOTAL */}
        <h4 style={{ marginTop: "30px" }}>
          Grand Total :{" "}
          {Object.keys(invoiceGroups)
            .reduce((grand, date) => {
              return (
                grand +
                Object.values(invoiceGroups[date]).reduce((sum, inv) => {
                  const student = studentData[inv.serialNo] || {};
                  return student.isActive !== false
                    ? sum + inv.paidAmount
                    : sum;
                }, 0)
              );
            }, 0)
            .toFixed(2)}
        </h4>
      </div>
    </div>
  );
}

export default Yearpavati;

